import PageDataLoader from '../../../lib/page-data/loader';
import {
  CLUB_ALBUM_RECEIVE,
  MATCH_CENTRE_PAGE_REQUEST,
  MATCH_CENTRE_PAGE_RECEIVE,
  MATCH_CENTRE_PAGE_FAILURE,
  MATCH_CENTRE_UPDATES_RECEIVE,
  MATCH_CENTRE_UPDATES_FAILURE,
  MATCH_CENTRE_UPDATES_VIEW,
  PAGE_DATA_LOAD,
} from '../../action-types';
import PageKey from '../../../lib/page-data/key';
import ApiRequestException from '../../../exceptions/api-request-exception';

export const fetchPageData = (clubId, teamId, fixtureId, request) => async (dispatch) => {
  try {
    dispatch({ type: MATCH_CENTRE_PAGE_REQUEST, payload: { teamId, fixtureId } });
    const pageKey = new PageKey(clubId, 'match_centre', { teamId, fixtureId });
    // We need to refresh this data after an hour, so that PlayCricket doesn't have
    // to be manually refreshed.
    const forceRefreshIntervalSeconds = 1 * 60 * 60; // 1 hour
    const pageData = await PageDataLoader.getPageData(
      pageKey,
      request,
      forceRefreshIntervalSeconds,
    );
    const { data, accessLevel } = pageData;
    dispatch({
      type: MATCH_CENTRE_PAGE_RECEIVE,
      payload: { teamId, fixtureId, data },
    });
    if (data && data.album) {
      dispatch({
        type: CLUB_ALBUM_RECEIVE,
        payload: { albumId: data.album.id, album: data.album },
      });
    }
    dispatch({ type: PAGE_DATA_LOAD, payload: pageKey.toString() });

    return { accessLevel };
  } catch (error) {
    let statusCode = 500;
    if (error) {
      statusCode = error.errorStatusCode || statusCode;
    }

    dispatch({
      type: MATCH_CENTRE_PAGE_FAILURE,
      payload: { teamId, fixtureId, statusCode, error },
    });
    return { error };
  }
};

export const fetchMatchUpdates = (clubId, teamId, fixtureId) => async (dispatch) => {
  try {
    const { makeIsomorphicApiRequest } = await import('../../../lib/api-proxy');
    const response = await makeIsomorphicApiRequest(
      `/v2/club-website/${clubId}/match-centre-updates/${teamId}-${fixtureId}`,
    );

    if (response.status !== 200) {
      dispatch({
        type: MATCH_CENTRE_UPDATES_FAILURE,
        payload: {
          teamId,
          fixtureId,
          error: new ApiRequestException('Error retrieving updates', response.status),
        },
      });
    } else {
      const { overview, eventsByPeriod } = await response.json();
      dispatch({
        type: MATCH_CENTRE_UPDATES_RECEIVE,
        payload: { teamId, fixtureId, eventsByPeriod, overview },
      });
    }
  } catch (error) {
    dispatch({
      type: MATCH_CENTRE_UPDATES_FAILURE,
      payload: { teamId, fixtureId, error },
    });
  }
};

export const viewMatchUpdates = (teamId, fixtureId) => (dispatch) => {
  dispatch({
    type: MATCH_CENTRE_UPDATES_VIEW,
    payload: { teamId, fixtureId },
  });
};
